import unhangPrepositions from './utils/unhangPrepositions';

const strings = {
  pageIsUnaccessible: 'Страница временно недоступна',
  error: 'Ошибка',
  tryReloadPage: 'Попробуйте обновить страницу сочетанием клавиш — Ctrl\u00a0+\u00a0F5. Если ошибка долго сохраняется, обратитесь\u00a0в техподдержку.',
  requestError: 'Произошла ошибка, повторите попытку позже',
  toPartnersLanding: 'К списку партнёров',
  partnerSiteUnavailable: 'Сайты некоторых банков могут не открываться в браузерах из-за перехода на российские сертификаты безопасности. Чтобы сайты работали правильно, установите сертификаты Минцифры либо используйте Яндекс\u00a0Браузер или Atom.',
  certificatesInstruction: 'Как установить сертификаты Минцифры:',
  certificatesInstructionLink: 'gosuslugi.ru/crt',
  advertizerNameText: 'Реклама ',
  advertizerInnText: 'ИНН ',
  advertizerErirText: 'ERID: ',
};

export default unhangPrepositions(strings);
